/*
 *
 * Do not edit directly
 * Generated on Fri, 14 Feb 2025 18:58:13 GMT
 *
 */


const theme = {
  appearances: {
    decorative: {
      description: 'Use a decorative divider to highlight an element. Non-decorative dividers are for clearly identifying separation of content.',
      type: 'variant',
      values: [ true ]
    },
    inverse: { type: 'variant', values: [ true ] },
    weight: { type: 'variant', values: [ 'thick' ] }
  },
  rules: [
    { if: { weight: 'thick' }, tokens: { width: 2 } },
    { if: { decorative: true }, tokens: { color: '#cdcfd5' } },
    { if: { inverse: true }, tokens: { color: '#ffffff' } }
  ],
  tokens: { color: '#9c9faa', width: 1 }
}
export default theme
